import { http } from '../common/utils';
import { FIREBASE_AUTH_BASE_URL } from '../common/constants';

export function createFirebaseToken(accessToken, schoolIds) {
  return http.post(`${FIREBASE_AUTH_BASE_URL}/auth/token`, {
    access_token: accessToken,
    school_ids: schoolIds,
  });
}
